import React from 'react';
import {useLoaderData} from '@remix-run/react';
import type {Collection} from '@shopify/hydrogen/storefront-api-types';

//components
import {Link} from 'components/Link';

//data
import {loader} from '~/routes/($lang)/products/$productHandle';

export default function ProductDetailsBreadcrumb() {
  const {product, collectionsForBreadcrumb, translation} = useLoaderData<typeof loader>();

  //TODO: Get Translations of collections
  return (
    <nav className="mb-[50px] flex flex-wrap items-center">
      <Link
        to="/"
        className="transition-colors duration-200 ease-out hover:text-hk-orange"
      >
        {translation.home}
      </Link>
      {collectionsForBreadcrumb ? (
        collectionsForBreadcrumb?.map((c) => (
          <span key={`${c.id}-separator`}>
            <span className="mx-2 inline-block">/</span>
            <Link
              to={`/collections/${c.handle}`}
              className="transition-colors duration-200 ease-out hover:text-hk-orange"
            >
              {c.title}
            </Link>
          </span>
        ))
      ) : (
        <span>
          <span className="mx-2 inline-block">/</span>
          <span className="transition-colors duration-200 ease-out hover:text-hk-orange">
            {product.title}
          </span>
        </span>
      )}
    </nav>
  );
}
